export default __webpack_public_path__ + "static/media/Succession_Policy_2.acaa68e3.pdf";